let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iwseV")).then(() => parcelRequire('e9Wyv'));